import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/dashboard/sidebar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/theme/landing-theme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider","SidebarInset"] */ "/app/src/components/ui/sidebar.tsx");
